import * as types from './actionTypes'

const initialState = {
    isLoading: false,
    record: {},
    recordId: null,
    recordTitle: '',
    entityId: null,
    initError: false,
    duplicated: null,
    deleted: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_RECORD:
            return {
                ...state,
                initError: false,
                isLoading: true,
                record: {},
                entityId: null
            }

        case types.FETCH_RECORD_SUCCESS:
            return {
                ...state,
                record: {...action.data.record},
                recordTitle: action.data.recordTitle,
                recordId: action.data.recordId,
                entityId: action.data.entityId,
                isLoading: false,
                initError: false
            }

        case types.FETCH_RECORD_FAILED:
            return {
                ...state,
                isLoading: false,
                initError: true
            }

        case types.DUPLICATE_RECORD_SUCCESS:
            return {
                ...state,
                duplicated: action.data.id
            }

        case types.DUPLICATE_RECORD_FAILED:
            return {
                ...state
            }

        case types.RESET_RECORD:
            return {
                ...state,
                duplicated: null,
				deleted: null
            }

        case types.DELETE_RECORD_SUCCESS:
            return {
                ...state,
                deleted: action.data[0]
            }

        case types.DELETE_RECORD_FAILED:
            return {
                ...state
            }

        default:
            return state
    }
}
